export default __webpack_public_path__ + "static/media/Nav-Features.9496688b.svg";